<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="订单号">
        <el-input
          v-model="formInline.orderid"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户名">
        <el-input
          v-model="formInline.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="手机(尾号)">
        <el-input
          v-model="formInline.usermobile"
          placeholder="请输入手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="支付方式">
        <el-select v-model="formInline.payType" placeholder="请选择">
          <el-option
            v-for="(item, index) in PAY_TYPE_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSearch"
          >查询</el-button
        >
      </el-form-item>
    </el-form>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="订单号">
        <template slot-scope="scope">
          <router-link
            class="link-div"
            tag="div"
            :to="{ name: 'order', query: { orderid: scope.row.orderid } }"
            >{{ scope.row.orderid }}</router-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="username" label="用户名">
        <template slot-scope="scope">
          <div v-html="scope.row.username"></div> </template
      ></el-table-column>
      <el-table-column prop="usermobile" label="手机号"> </el-table-column>
      <el-table-column prop="payAmount" label="支付金额"> </el-table-column>
      <el-table-column prop="transactionId" label="支付交易号">
      </el-table-column>
      <el-table-column prop="resultCode" label="支付结果"> </el-table-column>
      <el-table-column prop="errCode" label="错误码"> </el-table-column>
      <el-table-column prop="errCodeDes" label="错误描述"> </el-table-column>

      <el-table-column prop="payType" label="支付类型">
        <template slot-scope="scope">
          <div>
            {{ $getLabelByValue(scope.row.payType.toString(), PAY_TYPE_ENUM) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="isClosed" label="是否关闭（退款成功=关闭）">
        <template slot-scope="scope">
          <div>
            <el-tag type="" effect="dark" v-if="scope.row.isClosed"
              >已关闭</el-tag
            >
            <el-tag type="info" effect="dark" v-else>未关闭</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="创建时间">
        <template slot-scope="scope">
          <div>{{ scope.row.createtime | formatDateTime }}</div>
        </template>
      </el-table-column>
      <el-table-column label="修改时间">
        <template slot-scope="scope">
          <div>{{ scope.row.modifiedtime | formatDateTime }}</div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import enumObject from "../../plugins/enum";

export default {
  data() {
    return {
      formInline: {
        orderid: "",
        username: "",
        usermobile: "",
        payType: ""
      },
      tableData: [],

      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      PAY_TYPE_ENUM: enumObject.PAY_TYPE_ENUM
    };
  },
  methods: {
    onSearch() {
      let queryModel = {
        orderid: this.formInline.orderid,
        username: this.formInline.username,
        usermobile: this.formInline.usermobile,
        payType: this.formInline.payType,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询支付信息"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSearch();
    }
  },
  mounted() {
    this.onSearch();
  }
};
</script>

<style lang="less" scoped></style>
